import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Chip, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import TagIcon from "@mui/icons-material/Tag";

const MetaChip = ({ icon, label }) => {
  if (!label || label === "—") return null;
  return (
    <Chip
      size="small"
      icon={icon}
      label={label}
      variant="outlined"
      sx={{ fontWeight: 600 }}
    />
  );
};

const DashboardHeader = ({
  spaceName,
  spaceId,
  spaceType,
  onBack,
}) => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 1.5,
      mb: 2,
    }}
  >
    <Box sx={{ minWidth: 0, flex: 1 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        {typeof onBack === "function" ? (
          <Button
            size="small"
            startIcon={<ArrowBackIcon />}
            onClick={onBack}
            sx={{ minWidth: 0, px: 1, textTransform: "none" }}
          >
            Back
          </Button>
        ) : null}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            fontSize: { xs: 20, md: 24 },
            wordBreak: "break-word",
          }}
        >
          {spaceName || "Selected Space"}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, pl: onBack ? 7 : 0 }}>
        <MetaChip
          icon={<MeetingRoomIcon />}
          label={
            spaceType && spaceType !== "—" ? `Type: ${spaceType}` : null
          }
        />
        <MetaChip
          icon={<TagIcon />}
          label={spaceId ? `Space ID: ${spaceId}` : null}
        />
      </Box>
    </Box>
  </Box>
);

DashboardHeader.propTypes = {
  spaceName: PropTypes.string,
  spaceId: PropTypes.string,
  spaceType: PropTypes.string,
  onBack: PropTypes.func,
};

export default DashboardHeader;
